<template>
  <div class="market-history market-order mt15">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link active"
          id="position-holding-tab"
          data-bs-toggle="tab"
          data-bs-target="#position-holding"
          type="button"
          role="tab"
          aria-controls="position-holding"
          aria-selected="true"
          @click="activeTab = 'position-holding'"
        >
          Position holding
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="pending-orders-tab"
          data-bs-toggle="tab"
          data-bs-target="#pending-orders"
          type="button"
          role="tab"
          aria-controls="pending-orders"
          aria-selected="false"
          @click="activeTab = 'pending-orders'"
        >
          Pending Orders
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="order-history-tab"
          data-bs-toggle="tab"
          data-bs-target="#order-history"
          type="button"
          role="tab"
          aria-controls="order-history"
          aria-selected="false"
          @click="activeTab = 'order-history'"
        >
          History
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="position-holding"
        role="tabpanel"
        aria-labelledby="position-holding-tab"
      >
        <OrderList
          type="holding"
          :biList="biList"
          v-if="activeTab === 'position-holding'"
        />
        <!-- <ul class="d-flex justify-content-between market-order-item">
          <li>Time</li>
          <li>All pairs</li>
          <li>Buy/Sell</li>
          <li>Price</li>
          <li>Amount</li>
          <li>Executed</li>
          <li>Unexecuted</li>
        </ul>
        <span class="no-data">
          <i class="icon ion-md-document"></i>
          No data
        </span> -->
      </div>
      <div
        class="tab-pane fade"
        id="pending-orders"
        role="tabpanel"
        aria-labelledby="pending-orders-tab"
      >
        <OrderList
          type="pending"
          :biList="biList"
          v-if="activeTab === 'pending-orders'"
        />
      </div>
      <div
        class="tab-pane fade"
        id="order-history"
        role="tabpanel"
        aria-labelledby="order-history-tab"
      >
        <OrderList
          type="history"
          :biList="biList"
          @chooseBiById="chooseBiById"
          v-if="activeTab === 'order-history'"
        />
      </div>
    </div>
  </div>
</template>
<script>
import OrderList from "./order/order-list.vue";
export default {
  props: {
    biList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    OrderList,
  },
  data() {
    return {
      activeTab: "position-holding",
    };
  },
  methods: {
    chooseBiById(id, type) {
      this.$emit("chooseBiById", id, type)
    }
  }
};
</script>
